import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { QuoteApprovalScreen } from "@src/components/modules/auth/quote-approval";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { headTitle } from "@src/utils/head-title";
import { createFileRoute } from "@tanstack/react-router";

const QuoteApproval = ({ id }: WithIdProps) => {
  const title = headTitle(t`Quote Approval`);
  return (
    <>
      <NoIndexHead>
        <title>{title}</title>
        <meta key="title" property="og:title" content={title} />
      </NoIndexHead>
      <QuoteApprovalScreen id={id} />
    </>
  );
};

const RouteComponent = withId(QuoteApproval);

export const Route = createFileRoute("/quote-approval")({
  component: RouteComponent,
});
